"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = exports.init = exports.setup = void 0;
var shared_1 = require("@cian/peperrors/shared");
var shared_2 = require("../shared");
var sources_1 = require("../shared/sources");
var getScriptConfigParams_1 = require("./getScriptConfigParams");
var setupConfigParams = null;
var config = null;
function setup(params) {
    setupConfigParams = params;
}
exports.setup = setup;
function init() {
    if (!config) {
        config = loadConfig();
    }
    return config;
}
exports.init = init;
function getConfig() {
    if (!config) {
        throw new shared_1.ConfigurationError({
            message: 'Config must be created before accessing it. Forgot to call init() before accessing config?',
            domain: 'config.getConfig',
        });
    }
    return config;
}
exports.getConfig = getConfig;
function loadConfig() {
    var container = window._cianConfig;
    if (!container) {
        throw new shared_1.NotFoundError({
            message: "_cianConfig - not found in window",
            domain: 'config.loadConfig',
        });
    }
    var configParams = (0, getScriptConfigParams_1.getScriptConfigParams)() || {};
    if (setupConfigParams) {
        configParams = __assign(__assign({}, configParams), setupConfigParams);
    }
    var projectName = configParams.projectName;
    if (configParams.settingsKey) {
        projectName = configParams.settingsKey;
    }
    var settings = container[projectName];
    if (!settings) {
        throw new shared_1.NotFoundError({
            message: "Missing settings in _cianConfig.".concat(projectName),
            domain: 'config.loadConfig',
        });
    }
    if (!Array.isArray(settings)) {
        throw new shared_1.ValidationError({
            message: "Expecting array of settings in _cianConfig.".concat(projectName),
            domain: 'config.loadConfig',
            details: { payload: JSON.stringify(settings, null, 2) },
        });
    }
    settings.forEach(function (setting) {
        if (!(0, shared_2.validate)(setting)) {
            throw new shared_1.ValidationError({
                message: "Received unexpected entry in _cianConfig.".concat(projectName),
                domain: 'config.loadConfig',
                details: { setting: JSON.stringify(setting, null, 2) },
            });
        }
    });
    var source = new sources_1.SortedSource(settings);
    var config = new shared_2.Config({ source: source, matcher: new shared_2.Matcher() });
    return config.attach({
        requestId: configParams.requestId || undefined,
    });
}
//# sourceMappingURL=interface.js.map